import React from 'react';
import { connect } from 'react-redux';
import { Card } from '@ff-os/shared-react/components/card/Card';
import { Prefab } from '@ff-resource-plugins/prefabs-shared/Prefab';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PrefabPreviewMode } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import { applyPrefab, selectIsActivePrefab, selectPreviewBackgroundColor } from '../../_redux-prefabs';
import { PrefabPreview2d } from '../../preview/PrefabPreview2d';
import styles from './PrefabPickerGridItem.module.scss';

const _PrefabPickerGridItem = ({
    prefab, active, backgroundColor, mode, commit
}: Props) => (
    <Card className={styles[mode]} style={{ backgroundColor }} onClick={commit} active={active}>
        <PrefabPreview2d prefab={prefab} mode={mode} />
    </Card>
);

type Props = {
    prefab: Prefab;
    active: boolean;
    mode: PrefabPreviewMode;
    backgroundColor: string | undefined;
    commit: () => void;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { prefab: Prefab }) => ({
    backgroundColor: selectPreviewBackgroundColor(state, ownProps.prefab.id),
    active: selectIsActivePrefab(state, ownProps.prefab.id)
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { prefab: Prefab }) => ({
    commit: () => dispatch(applyPrefab(ownProps.prefab))
});

export const PrefabPickerGridItem = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PrefabPickerGridItem);